import React from 'react';
import LearningCard from '../components/LearningCard';

const PrivateSale = () => (
  <LearningCard
    testid="private-sale"
    title="Private Sale Microlearning"
    subtitle="Please select your language to open the training."
    support="This microlearning is intended for store teams and sales associates."
    buttons={[
      {
        label: 'Nederlands',
        href: 'https://app.qoldo.com/p/410a48e0-6f54-4be2-adb6-8c7ff9c21d46?t=15ff0ad3-b420-496d-a66d-571d5f51db04',
        testid: 'btn-nederlands',
      },
      {
        label: 'English',
        href: 'https://app.qoldo.com/p/1ebdd030-a989-4295-b835-8eb58d8eb6ca?t=b04a0e24-af62-49cb-ab4c-ad24e29d3a82',
        variant: 'outline',
        testid: 'btn-english',
      },
    ]}
  />
);

export default PrivateSale;
